import { render, staticRenderFns } from "./dialogPhone.vue?vue&type=template&id=90b5c07e&scoped=true&"
import script from "./dialogPhone.vue?vue&type=script&lang=js&"
export * from "./dialogPhone.vue?vue&type=script&lang=js&"
import style0 from "./dialogPhone.vue?vue&type=style&index=0&id=90b5c07e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b5c07e",
  null
  
)

export default component.exports